import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { REPLACE_USER } from '../common/constants/reduxConstants'

type InformedConsentBannerState = {
  /**
   * Appointment whose in-session informed-consent banner the provider dismissed, or null if none.
   * Persisted (see the root persistConfig whitelist in store.ts) so the banner stays dismissed
   * for the rest of that session even if the provider refreshes and rejoins. A stale id from a
   * past appointment is inert because it won't match the current session's appointment, so the
   * banner shows again for the next session if the consent is still unsigned.
   */
  dismissedAppointmentId: number | null
}

const initialState: InformedConsentBannerState = {
  dismissedAppointmentId: null,
}

const informedConsentBannerSlice = createSlice({
  name: 'informedConsentBanner',
  initialState,
  reducers: {
    dismissInformedConsentBanner: (state, action: PayloadAction<number>) => {
      state.dismissedAppointmentId = action.payload
    },
  },
  extraReducers: (builder) => {
    // A supervisor switching into another provider must not inherit that provider's dismissal.
    builder.addCase(REPLACE_USER, () => initialState)
  },
})

export const { dismissInformedConsentBanner } = informedConsentBannerSlice.actions
export default informedConsentBannerSlice.reducer
